import { Input } from 'antd';
import React from 'react';
import { useFilterLabelClassName, useFilterContainerClassName, useFilterInputContainerClassName } from '../../../../utils/languageUtils';

interface BagTaskNumberFilterItemProps {
    label: string;
    value?: string;
    onChange?: (value: string | undefined) => void;
    className?: string;
    spanClassName?: string;
    disabled?: boolean;
    placeholder?: string;
}

const BagTaskNumberFilterItem: React.FC<BagTaskNumberFilterItemProps> = ({
    label,
    value,
    onChange,
    className,
    spanClassName,
    disabled,
    placeholder = "enter bagging task numbers"
}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value;
        if (onChange) {
            onChange(inputValue || undefined);
        }
    };

    // 使用统一的样式 Hook，根据语言自动返回合适的样式类名
    const containerClassName = useFilterContainerClassName(className);
    const labelClassName = useFilterLabelClassName(spanClassName);
    const inputContainerClassName = useFilterInputContainerClassName();

    return (
        <div className={containerClassName}>
            <span className={labelClassName}>{label}</span>
            <div className={inputContainerClassName}>
                <Input
                    placeholder={placeholder}
                    value={value}
                    allowClear
                    onChange={handleChange}
                    disabled={disabled}
                    size="small"
                    className="h-8"
                />
            </div>
        </div>
    );
};

export default BagTaskNumberFilterItem;

